/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Update CDC (event notifications) configuration. If systemControlled is true, sets config to \'auto\' (system decides when to use CDC). If systemControlled is false, must provide enabled to set \'force-true\' or \'force-false\' (user controls CDC usage).
*/
export class UpdateCloudResourceConfigurationRequestCdcBackup {
  /**
  * Whether CDC is enabled. Required when systemControlled is false. Ignored when systemControlled is true.
  */
  'enabled'?: boolean | null;
  /**
  * Whether to let the system decide when to use CDC (true = \'auto\', false = user controls with \'force-true\'/\'force-false\')
  */
  'systemControlled'?: boolean | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "enabled",
      "baseName": "enabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "systemControlled",
      "baseName": "systemControlled",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return UpdateCloudResourceConfigurationRequestCdcBackup.attributeTypeMap;
  }

  public constructor() {
  }
}

